import * as React from 'react';
import { alpha, styled } from "@mui/material/styles"
import InputBase from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { useState, useEffect } from 'react';

const CustomInput = styled(InputBase)(({ theme, labelMargin }) => ({
  'label + &': {
    marginTop: labelMargin ?? theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    fontSize: "1rem",
    width: 'auto',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    padding: "4px 8px",
    margin: 0,
    fontFamily: "Open Sans",
  },
  '& .MuiInputBase-input:not([readonly])': {
    backgroundColor: 'var(--background-lightgray)'
  },
  "& .MuiInputBase-input:not([readonly]):focus": {
    boxShadow: `${alpha(theme.palette.primary.main, 1)} 0 0 0 0.1rem`,
    borderColor: theme.palette.primary.main,
  },
}));

const InputFieldDataProfile = ({
  label = "",
  value,
  onChange,
  onBlur,
  onKeyUp,
  edit,
  inputType = "text",
  InputProps,
  name,
  sx
}) => {
  const [inputProps, setInputProps] = useState({readOnly: true})
  const [id] = useState(() => window.crypto.randomUUID());

  useEffect(() => {
    if (edit)
    {
      setInputProps({...InputProps, readOnly: false})
    }
    else
    {
      setInputProps({...InputProps, readOnly: true})
    }
  }, [InputProps, edit])

  return (
    <FormControl variant="standard" sx={sx}>
      <InputLabel shrink htmlFor={id} sx={{fontWeight: "400", color: "var(--grey-inactive)", fontSize: "1.25rem", maxWidth: '150% !important'}}>
        {label}
      </InputLabel>
      <CustomInput value={value} id={id}
        inputProps={inputProps} 
        onChange={e => onChange?.(e)}
        onBlur={e => onBlur?.(e)}
        onKeyUp={e => onKeyUp?.(e)}
        type={inputType}
        name={name}
        labelMargin={InputProps?.labelMargin}
        />
    </FormControl>
  )
}

export default InputFieldDataProfile;